import { useMutation } from '@tanstack/react-query'
import { useGoogleAPI } from 'ComponentLibrary/src/molecules/AddressSearch/useGoogleAPI'

type UseGooglePlacesAPIProps = {
    apiKey: string
    language?: string
    onError?: (error: Error) => void
}

export const useGooglePlacesAPI = ({ apiKey, language, onError }: UseGooglePlacesAPIProps) => {
    const { autocompleteService } = useGoogleAPI(apiKey, language)

    const {
        mutateAsync: fetchPlaceSuggestionsAsync,
        isError,
        isPending,
    } = useMutation({
        mutationFn: async ({ input }: { input: string }) => {
            if (autocompleteService === undefined) {
                throw Error('Make sure to only fetch when the google maps service is loaded')
            }
            return autocompleteService.getPlacePredictions({ input: input.trim() })
        },
        onError,
    })

    return {
        fetchPlaceSuggestionsAsync,
        finishedInitialization: autocompleteService !== undefined,
        isPending,
        isError,
    }
}
